import { useMutation } from '@apollo/client';
import { FormikProvider, useFormik } from 'formik';
import { useState } from 'react';
import { ENABLE_TOTP } from '../../http/apollo-queries';
import { Button } from '../UI';
import { InputCode } from '../form';
import PopupWindow from '../Popup-window/Popup-window';
import { ScanQRPropsModel } from './scan-qr-props.model';
import { useTranslation } from 'react-i18next';
import { pascalCase } from '../../helpers/functions';

const ScanQR = (props: ScanQRPropsModel) => {
  const [isScanQRStep, setIsScanQRStep] = useState(true);
  const [enableTOTP, { loading: enableTOTPLoading }] = useMutation(ENABLE_TOTP);
  const [TOTPErr, setTOTPErr] = useState('');
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      code: '',
    },
    onSubmit: (values) => {
      enableTOTP({
        variables: {
          code: values.code,
        },
      })
        .then(({ data: { enableTOTP } }) => {
          if (enableTOTP.status === 'SUCCESS') {
            props.handleSuccess();
            props.handleCancelClick();
          } else {
            setTOTPErr(t('scanQR.error.invalidCode'));
          }
        })
        .catch((error) => {
          setTOTPErr(
            t('scanQR.error' + pascalCase(error.message), error.message)
          );
        });
    },
    validateOnMount: true,
  });

  const scanQRStep = () => (
    <PopupWindow
      title={t('scanQR.title')}
      subtitle={t('scanQR.subtitle')}
      onCloseClick={props.handleCancelClick}
    >
      <img src={props.qrCode} alt="" />
      <span className="mt-2 text-black font-semibold">
        {t('scanQR.haveProblem')}
      </span>
      <span className="mt-1 text-grey-50">{t('scanQR.useKey')}</span>
      <div className="flex items-center h-11 rounded-lg border border-grey-10 px-3 mt-3">
        <span className="text-sm">{props.secret}</span>
      </div>
      <div className="mt-6 flex gap-4">
        <Button
          type="button"
          variant="secondary"
          buttonClass="w-24"
          onClick={() => {
            setIsScanQRStep(false);
            props.handleCancelClick();
          }}
        >
          {t('scanQR.cancel')}
        </Button>
        <Button
          type="submit"
          variant="primary"
          buttonClass="w-24"
          onClick={() => setIsScanQRStep(false)}
        >
          {t('scanQR.continue')}
        </Button>
      </div>
    </PopupWindow>
  );

  const inputCodeStep = () => (
    <PopupWindow
      title={t('scanQR.insertCode')}
      subtitle={t('scanQR.insertCodeDescription')}
      onCloseClick={props.handleCancelClick}
    >
      <FormikProvider value={formik}>
        <form onSubmit={formik.handleSubmit}>
          <div className="mt-12">
            <InputCode
              name="code"
              id="code"
              numberOfDigits={6}
              formik={formik}
              label="2FA code"
              errorMessage={TOTPErr}
            />
          </div>
          <div className="mt-10">
            <Button
              type="submit"
              variant="primary"
              buttonClass="w-64"
              loading={enableTOTPLoading}
            >
              {t('scanQR.continue')}
            </Button>
          </div>
        </form>
      </FormikProvider>
    </PopupWindow>
  );

  return <>{isScanQRStep ? scanQRStep() : inputCodeStep()}</>;
};

export default ScanQR;
